import JourneyChronologyEntries from './JourneyChronologyEntries'
import { useState } from 'react'
import { ChevronDown, ChevronRight, ListOrdered } from 'lucide-react'
import { useGetJourneyChronologyQuery } from '../services/taskActionsApi'
import type { TaskActionMeta } from './TaskActionsSection'
import './JourneyChronologySection.css'

interface Props { taskId: string; active: boolean; actions: TaskActionMeta[] }

export default function JourneyChronologySection({ taskId, active, actions }: Props) {
  const [expanded, setExpanded] = useState(false)
  const { currentData: data, isFetching, error, refetch } = useGetJourneyChronologyQuery(
    { taskId, active },
    { skip: !expanded, pollingInterval: active && expanded ? 10_000 : 0, refetchOnMountOrArgChange: true },
  )
  return <section className="task-detail__section journey-chronology">
    <button type="button" className="task-detail__section-toggle" onClick={() => setExpanded(!expanded)}
      aria-expanded={expanded} aria-controls="journey-chronology-content"
      data-analytics-event="chronology-toggle" data-testid="chronology-toggle">
      {expanded ? <ChevronDown size={15} /> : <ChevronRight size={15} />}
      <ListOrdered size={15} /> Chronology{data ? ` (${data.entries.length})` : ''}
    </button>
    {expanded && <div id="journey-chronology-content" className="task-detail__logs">
      <p>Page observations and actions in execution order. Step summaries include the outcome after any recovery.</p>
      {isFetching && !data && <p role="status">Loading chronology…</p>}
      {error && <p role="alert">Could not load chronology. <button type="button" onClick={() => void refetch()} data-analytics-event="chronology-retry">Retry</button></p>}
      {data && (data.entries.length
        ? <JourneyChronologyEntries entries={data.entries} actions={actions} />
        : <p>{active ? 'Waiting for journey execution to record its first entry…' : 'No chronology was captured for this run. Older runs do not have stored chronology.'}</p>)}
    </div>}
  </section>
}
